<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Listar {{ this.$gui.tickets }}</h2>
        </b-col>
      </b-row>

      <b-row>
        <b-col>
          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">{{ this.$gui.tickets }}:</p>
            <b-form-checkbox-group>
              <b-form-checkbox-group @input="updateForm('type', $event)" :checked="filters.type" :options="typeOptions"></b-form-checkbox-group>
            </b-form-checkbox-group>
          </b-form-group>

          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Status:</p>
            <b-form-checkbox-group @input="updateForm('status', $event)" :checked="filters.status" :options="statusOptions"></b-form-checkbox-group>
          </b-form-group>

          <b-form-group class="w-auto d-inline-block mb-3">
            <p class="mb-2 font-weight-bold">Outros:</p>
            <b-form-checkbox :checked="filters.onlyReprinted" @change="updateForm('onlyReprinted', $event)">Somente reimpressos</b-form-checkbox>
          </b-form-group>
        </b-col>
      </b-row>

      <b-row align-v="end">
        <b-col>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Filtros:</p>
            <b-button class="mr-1 mb-1" v-b-modal.filter-origin>Origem</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-number>Número</b-button>
            <b-button v-if="$gui.isEvento" class="mr-1 mb-1" v-b-modal.filter-code>Código</b-button>
            <b-button v-if="!randomNumberEnabled" class="mr-1 mb-1" v-b-modal.filter-range>Intervalo</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-batch>{{ this.$gui.batch }}</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-dealer>{{ this.$gui.dealer }}</b-button>
            <b-button class="mr-1 mb-1" v-b-modal.filter-date>Data geração</b-button>
          </div>
          <div style="width: 110px;" class="d-inline-block mr-4 mb-4">
            <p class="mb-2 font-weight-bold">Quantidade:</p>
              <b-form-input size="sm" type="number" @input="updateForm('limit', $event)" :value="filters.limit"></b-form-input>
          </div>
          <div class="w-auto d-inline-block mr-4 mb-4">
            <b-button class="mr-1" variant="info" @click="showLast">Limpar filtros</b-button>
            <b-button class="mr-1" variant="info" @click="filter">Filtrar</b-button>
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col cols="12" v-if="hasFilters" class="mt-1 mb-3">
          <b-card-group>
            <b-card no-body>
              <b-list-group flush>
                <b-list-group-item v-for="(item, index) in appliedFilters" :key="index">
                  <strong>{{ item.filter }}:</strong> {{ item.values }}
                </b-list-group-item>
                <b-list-group-item v-if="ticketCanBeReprinted">
                  <b-button variant="success" @click="reprint">Reimprimir</b-button>
                </b-list-group-item>
              </b-list-group>
            </b-card>
          </b-card-group>
        </b-col>

        <b-col cols="12" class="mt-0">
          <p class="m-0">{{ stats }}</p>
        </b-col>

        <b-col cols="12" class="mt-3">
          <b-table striped hover show-empty
            :items="tickets"
            :fields="this.$gui.isEvento ? fieldsEvento : fieldsFicha"
            primary-key="number"
            sort-icon-left
            :empty-filtered-text="this.$gui.emptyTicket"
            :empty-text="this.$gui.emptyTicket"
            responsive>

              <!-- Coluna: Status -->
              <template v-slot:head(statusStyled)="">
                <div>
                  Status
                  <span v-b-tooltip.hover title="Ingressos validados parcialmente ou não validados aparecem com status Ativo.">
                    <icon name="info-circle" scale="0.8"></icon>
                  </span>
                </div>
              </template>

              <template v-slot:cell(statusStyled)="data">
                <div>
                  <div v-if="data.item.status === 'canceled' && data.item.canceled_by === 'admin'">
                    <b-badge pill variant="danger">
                      Cancelado
                    </b-badge> <icon scale="0.92" class="ml-1 text-secondary" name="user-shield" v-b-tooltip.hover.right="'Cancelado via Administrador'"></icon>
                  </div>
                  <div v-else-if="data.item.status === 'canceled' && data.item.canceled_by === 'transfer'">
                    <b-badge pill variant="danger">
                      Cancelado
                    </b-badge> <icon scale="0.92" class="ml-1 text-danger" name="exchange-alt" v-b-tooltip.hover.right="'Cancelado via Alteração de Titularidade'"></icon>
                  </div>
                  <div v-else-if="data.item.status === 'canceled' && data.item.canceled_by === 'pos'">
                    <b-badge pill variant="danger">
                      Cancelado
                    </b-badge> <icon scale="0.92" class="ml-1 text-danger" name="cash-register" v-b-tooltip.hover.right="'Cancelado via Maquininha'"></icon>
                  </div>                  
                  <b-badge v-else-if="data.item.status === 'validated'" pill variant="success">Validado</b-badge>
                  <b-badge v-else pill variant="primary">Ativo</b-badge>
                </div>
              </template>

              <template v-slot:cell(owner_data)="data">
                <div v-if="data.item.owner && data.item.owner.name && data.item.owner.document && data.item.owner.phone">
                  <ul>
                    <li>{{ data.item.owner.name }}</li>
                    <li>{{ data.item.owner.document }}</li>
                    <li><b-link target="_blank" :href="mountWhatsAppLink(data.item.owner.phone)">{{ data.item.owner.phone }}</b-link> <icon scale="0.55" name="external-link-alt"></icon></li>
                  </ul>
                </div>
              </template>

              <!-- Coluna: Validação -->
              <template v-slot:head(validation_stats_fmted)="">
                <div>
                  Validação
                  <span v-b-tooltip.hover title="Exemplo: 1/2 quer dizer que o ingresso foi validado 1 vez de um limite máximo de 2 vezes.">
                    <icon name="info-circle" scale="0.8"></icon>
                  </span>
                </div>
              </template>

              <template v-slot:cell(validation_stats_fmted)="data">
                <span>{{ data.item.validation_stats }}</span>
              </template>

              <template v-slot:cell(reprints)="data">
                <router-link
                  v-if="data.item.reprints > 0"
                  :to="{ name: 'OrganizerTicketReprints', params: { organizer: organizer, number: data.item.number } }">
                  {{ data.item.reprints }}
                </router-link>
                <span v-else>0</span>
              </template>

          </b-table>
        </b-col>
      </b-row>

    </b-container>

    <modal v-if="showModal">
      <router-view name="content"/>
    </modal>

    <b-modal id="filter-origin"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Origem"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('origins', $event)"
          :checked="filters.origins"
          :options="originsOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-dealer"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      :title="'Filtrar por ' + this.$gui.dealer"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.dealer"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.dealer" @click="search.dealer = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('dealers', $event)"
          :checked="filters.dealers"
          :options="dealersOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-batch"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      :title="'Filtrar por ' + this.$gui.batch"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Marque um ou mais e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-form-group v-if="categoriesFromBatches.length > 0" label="Filtrar por categoria:">
        <b-form-select v-model="selectedCategoryFilter" :options="categoriesFromBatches" @change="filterByCategory"></b-form-select>
      </b-form-group>

      <b-input-group class="mb-3" size="sm">
        <b-form-input
          v-model="search.batch"
          placeholder="Pesquisa rápida"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!search.batch" @click="search.batch = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>

      <b-form-group>
        <b-form-checkbox-group
          @input="updateForm('batches', $event)"
          :checked="filters.batches"
          :options="batchesOptions"
          stacked
        ></b-form-checkbox-group>
      </b-form-group>
    </b-modal>

    <b-modal id="filter-number"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Número"
      ok-variant="info"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('numbers', $event)"
          :value="filters.numbers"
          placeholder="Exemplo: 1,2,3"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.numbers" @click="filters.numbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-code"
      scrollable
      ok-only
      ok-title="Filtrar"
      title="Filtrar por Código"
      ok-variant="info"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe os códigos e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('codes', $event)"
          :value="filters.codes"
          placeholder="Exemplo: 05a2c30de2e4c19bd8b5ae855ca40f00"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.codes" @click="filters.codes = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-range"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Intervalo"
      @ok="filter"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Informe o intervalo de números e clique em <span class="font-weight-bold">Filtrar</span></p>

      <b-input-group class="mb-3">
        <b-form-input
          @input="updateForm('rangeNumbers', $event)"
          :value="filters.rangeNumbers"
          placeholder="Exemplo: 1-25"
          :autofocus="true"
          type="search"
        ></b-form-input>
        <b-input-group-append>
          <b-button size="sm" :disabled="!filters.rangeNumbers" @click="filters.rangeNumbers = ''">Limpar</b-button>
        </b-input-group-append>
      </b-input-group>
    </b-modal>

    <b-modal id="filter-date"
      scrollable
      ok-only
      ok-title="Filtrar"
      ok-variant="info"
      title="Filtrar por Data"
      @ok="filter"
      :ok-disabled="filters.createdAt.start === '' || filters.createdAt.end === ''"
    >
      <p class="text-info"><icon name="info-circle" scale="1.1"></icon> Para filtrar um <span class="font-weight-bold">intervalo de datas</span>, selecione dois dias. Para filtrar um <span class="font-weight-bold">dia específico</span>, clique duas vezes nele. Após isso clique em <span class="font-weight-bold">Filtrar</span>.</p>
      
      <div class="text-center">
        <calendar 
          @input="updateForm('createdAt', $event)"
          :value="filters.createdAt"
          :min-date="eventCreatedAt"
        >
        </calendar>
      </div>
    </b-modal>
  </div>
</template>

<script>
import MaskedInput from 'vue-text-mask'
import Calendar from '@/components/Calendar'
import Modal from '@/components/Modal'
import FilterStore from '@/filterStore'

export default {
  name: 'OrganizerListTickets',
  components: {
    MaskedInput,
    Calendar,
    Modal
  },
  data () {
    return {
      showModal: this.$route.meta.showModal,
      currentStatus: null,
      organizer: '',
      randomNumberEnabled: false,
      totalTickets: 0,
      batches: [],
      dealers: [],
      tickets: [],
      appliedFilters: [],
      selectedCategoryFilter: null,
      filters: {
        limit: 10,
        dealers: [],
        batches: [],
        numbers: '',
        codes: '',
        rangeNumbers: '',
        createdAt: {
          start: '',
          end: ''
        },
        type: ['printed', 'digital'],
        origins: [],
        status: ['active', 'validated', 'canceled'],
        onlyReprinted: false
      },
      search: {
        dealer: '',
        batch: ''
      },
      fieldsEvento: [
        { key: 'number', label: 'Nro.', class: ['align-middle', 'text-center'] },
        { key: 'statusStyled', label: 'Status', formatter: this.$options.filters.ticketStatus, class: ['align-middle', 'text-center'] },
        { key: 'name', label: this.$gui.batch, class: ['align-middle', 'text-nowrap'] },
        { key: 'dealer', label: this.$gui.dealer, class: ['align-middle', 'text-nowrap'] },
        { key: 'type', label: 'Tipo', formatter: this.$options.filters.ticketType, class: ['align-middle', 'text-center'] },
        { key: 'origin', label: 'Origem', formatter: this.$options.filters.ticketOrigin, class: ['align-middle', 'text-center', 'text-nowrap'] },
        { key: 'validation_stats_fmted', label: 'Validados', class: ['align-middle', 'text-center', 'text-nowrap'] },
        { key: 'created_at', label: 'Data geração', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'reprints', label: 'Reimpressões', class: ['align-middle', 'text-center'] },
        { key: 'owner_data', label: 'Titular', tdClass: ['owner-data-column'], class: ['text-center', 'align-middle', 'text-nowrap'] },
      ],
      fieldsFicha: [
        { key: 'number', label: 'Nro.', class: ['align-middle', 'text-center'] },
        { key: 'statusStyled', label: 'Status', formatter: this.$options.filters.ticketStatus, class: ['align-middle', 'text-center'] },
        { key: 'name', label: this.$gui.batch, class: ['align-middle', 'text-nowrap'] },
        { key: 'dealer', label: this.$gui.dealer, class: ['align-middle', 'text-nowrap'] },
        { key: 'value', label: 'Preço', formatter: this.$options.filters.currency, class: ['align-middle', 'text-center', 'text-nowrap'] },
        { key: 'type', label: 'Tipo', formatter: this.$options.filters.ticketType, class: ['align-middle', 'text-center'] },
        { key: 'origin', label: 'Origem', formatter: this.$options.filters.ticketOrigin, class: ['align-middle', 'text-center', 'text-nowrap'] },
        { key: 'created_at', label: 'Data geração', formatter: this.$options.filters.date, class: ['align-middle', 'text-nowrap', 'text-center'] },
        { key: 'reprints', label: 'Reimpressões', class: ['align-middle', 'text-center'] },
      ],
      originsOptions: [
        { text: 'Sistema', value: 'dashboard' },
        { text: 'Aplicativo', value: 'app' },
        { text: 'Loja virtual', value: 'shop' },
      ],
      statusOptions: [
        { text: 'Ativos', value: 'active' },
        { text: 'Validados', value: 'validated' },
        { text: 'Cancelados', value: 'canceled' },
      ],
      typeOptions: [
        { text: 'Impressos', value: 'printed' },
        { text: 'Digitais', value: 'digital' },
      ],
      eventCreatedAt: '',
      filterStore: ''
    }
  },
  watch: {
    '$route.meta' ({showModal}) {
      this.showModal = showModal
    }
  },
  async created () {
    this.filterStore = new FilterStore(this.$route.params.organizer, this.$route.path)

    let today = new Date()

    if (!this.$gui.isEvento) {
      this.filters.createdAt.start = this.$moment(today.setHours(0, 0, 0)).format('DD/MM/YYYY HH:mm')
      this.filters.createdAt.end = this.$moment(today.setHours(23, 59, 59)).format('DD/MM/YYYY HH:mm')
    }

    this.filters = this.filterStore.merge(this.filters)
  },
  async mounted () {
    this.organizer = this.$route.params.organizer
    await this.getEvent()
    await this.filter() 
  },
  methods: {
    updateForm (input, value) {
      this.filters[input] = value
      this.filterStore.save(input, value)
    },
    filterByCategory (catId) {
      if (!catId) return
      const ids = this.batches.filter(b => b.category && b.category.id === catId).map(b => b.id)
      this.updateForm('batches', ids)
    },
    async getEvent () {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/events'

      try {
        let res = await this.$http.get(url)

        if (res.body.batches.length > 0) {
          this.batches = this.$_.orderBy(res.body.batches, ['id'], ['asc'])
        }

        if (res.body.dealers.length > 0) {
          this.dealers = this.$_.orderBy(res.body.dealers, ['id'], ['asc'])
        }

        this.totalTickets = res.body.print_amount - res.body.cancel_amount
        this.eventCreatedAt = this.$moment(res.body.created_at).format('YYYY-MM-DD 00:00:00')
        this.randomNumberEnabled = res.body.random_number_enabled === 1

        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    async getTickets (filters) {
      let url = process.env.VUE_APP_URL_APP + '/b/organizers/' + this.organizer + '/tickets'

      if (filters !== '' && filters !== undefined) {
        url = url + '?' + filters
      }

      try {
        let resp = await this.$http.get(url)
        this.tickets = resp.body.tickets
        return true
      } catch (e) {
        console.error(e)
      }
      return false
    },
    reset () {
      this.appliedFilters = []
      this.filters.dealers = []
      this.filters.batches = []
      this.filters.numbers = ''
      this.filters.codes = ''
      this.filters.rangeNumbers = ''
      this.filters.createdAt.start = ''
      this.filters.createdAt.end = ''
      this.filters.type = ['printed', 'digital']
      this.filters.origins = []
      this.filters.status = ['active', 'validated', 'canceled']
      this.filters.onlyReprinted = false
      this.filters.limit = 10
      this.filterStore.clear()
    },
    async filter () {
      let filters = []
      this.appliedFilters = []

      if (this.filters.dealers.length > 0) {
        filters.push('dealers=' + this.$_.join(this.filters.dealers, ','))

        let v = []
        this.$_.each(this.filters.dealers, f => {
          let s = this.$_.find(this.dealers, d => d.id === f)
          v.push(s.name)
        })
        let af = {
          filter: 'Revendedor',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.origins.length > 0) {
        filters.push('origins=' + this.$_.join(this.filters.origins, ','))

        let v = []
        this.$_.each(this.filters.origins, f => {
          let s = this.$_.find(this.originsOptions, d => d.value === f)
          v.push(s.text)
        })
        let af = {
          filter: 'Origem',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.batches.length > 0) {
        filters.push('batches=' + this.$_.join(this.filters.batches, ','))

        let v = []
        this.$_.each(this.filters.batches, f => {
          let s = this.$_.find(this.batches, d => d.id === f)
          v.push(s.name)
        })
        let af = {
          filter: 'Lote',
          values: this.$_.join(v, ', ')
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.limit > 0) {
        filters.push('limit=' + this.filters.limit)
      }

      if (this.filters.numbers !== '') {
        filters.push('numbers=' + this.filters.numbers)

        let af = {
          filter: 'Número',
          values: this.filters.numbers
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.codes !== '') {
        filters.push('codes=' + this.filters.codes)

        let af = {
          filter: 'Código',
          values: this.filters.codes
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.rangeNumbers !== '') {
        filters.push('range_numbers=' + this.filters.rangeNumbers)

        let split = this.$_.split(this.filters.rangeNumbers, '-', 2)

        let af = {
          filter: 'Intervalo',
          values: 'Do ' + split[0] + ' até o ' + split[1]
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.start !== '') {
        let start = this.$moment(this.filters.createdAt.start, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('start_created_at=' + start + ':00')

        let af = {
          filter: 'Impressão',
          values: 'A partir de ' + this.filters.createdAt.start
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.createdAt.end !== '') {
        let end = this.$moment(this.filters.createdAt.end, 'DD/MM/YYYY HH:mm').format('YYYY-MM-DD HH:mm')
        filters.push('end_created_at=' + end + ':59')

        let af = {
          filter: 'Impressão',
          values: 'Até ' + this.filters.createdAt.end
        }

        this.appliedFilters.push(af)
      }

      if (this.filters.type.length > 0) {
        filters.push('type=' + this.$_.join(this.filters.type, ','))
      }

      if (this.filters.status.length > 0) {
        filters.push('status=' + this.$_.join(this.filters.status, ','))
      }

      if (this.filters.onlyReprinted) {
        filters.push('only_reprinted=1')

        let af = {
          filter: 'Outros',
          values: 'Somente reimpressos'
        }

        this.appliedFilters.push(af)
      }

      if (filters.length > 0) {
        filters = this.$_.join(filters, '&')
      }

      await this.getTickets(filters)
    },
    async reprint () {
      let numbers = this.$_.reduce(this.tickets, (result, ticket) => {
        result.push(ticket.number)
        return result
      }, [])

      let msg = ''

      if (numbers.length === 1) {
        msg += `Quer mesmo reimprimir este ingresso?`
      } else {
        msg += `Quer mesmo reimprimir estes ${numbers.length} ingressos?`
      }

      const action = await this.$bvModal.msgBoxConfirm(msg, {
        title: '⚠ Atenção',
        okVariant: 'success',
        cancelVariant: 'danger',
        okTitle: 'Sim',
        cancelTitle: 'Não ',
        centered: true,
        hideHeaderClose: false
      })

      if (action === false || !action) {
        return false
      }

      let route = this.$router.resolve({
        name: 'OrganizerReRenderTickets',
        params: {
          organizer: this.organizer,
          numbers: this.$_.join(numbers, ',')
        }
      })
      window.open(route.href, '_blank')
    },
    async showAll () {
      if (this.totalTickets > 500) {
        const action = await this.$bvModal.msgBoxConfirm(`Listar todos ingressos pode demorar alguns segundos.`, {
          title: '⚠ Atenção',
          okVariant: 'success',
          cancelVariant: 'danger',
          okTitle: 'Continuar',
          cancelTitle: 'Cancelar ',
          centered: true,
          hideHeaderClose: false
        })

        if (action === false || !action) {
          return false
        }
      }
      this.reset()
      await this.getTickets()
    },
    async showLast () {
      this.reset()
      await this.getTickets('limit=10')
    },
    mountWhatsAppLink (phone) {
      if (!phone) return
      let numbers = String(phone).replace(/\D/g, '')
      return `https://api.whatsapp.com/send?phone=55${numbers}`
    }
  },
  computed: {
    dealersOptions () {
      let filtered = this.dealers

      if (this.search.dealer) {
        filtered = this.$_.filter(this.dealers, d => {
          let searched = this.search.dealer.toLowerCase()
          return d.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    batchesOptions () {
      let filtered = this.batches

      if (this.search.batch) {
        filtered = this.$_.filter(this.batches, b => {
          let searched = this.search.batch.toLowerCase()
          return b.name.toLowerCase().indexOf(searched) >= 0
        })
      }

      return this.$_.map(filtered, b => {
        return {text: b.name, value: b.id}
      })
    },
    categoriesFromBatches () {
      const seen = {}
      const opts = [{ value: null, text: 'Selecione uma categoria...' }]
      for (const b of this.batches) {
        if (b.category && !seen[b.category.id]) {
          seen[b.category.id] = true
          opts.push({ value: b.category.id, text: `${b.category.emoji} ${b.category.category}` })
        }
      }
      return opts.length > 1 ? opts : []
    },
    ticketCanBeReprinted () {
      return this.tickets.length > 0 && this.filters.type.length === 1 && this.filters.type[0] === 'printed'
    },
    hasFilters () {
      return this.appliedFilters.length !== 0
    },
    stats () {
      let qty = this.tickets.length

      if (qty === 1) {
        return `Exibindo 1 ${this.$gui.ticketLC}`
      } else if (qty > 1) {
        return `Exibindo ${qty} ${this.$gui.ticketLC}s`
      }
      return ''
    }
  }
}
</script>

<style lang="scss">
.dropdown300 {
  width: 300px !important;
  overflow: hidden;
}
.owner-data-column {
  div {
    font-size: 11px;
    line-height: 13px;
    ul {
      list-style-type: none;
      padding: 0;
      margin: 0;
      li {
        margin-bottom: 3px;
      }
    }
  }
}
</style>
